<ngx-loading [show]="loading"></ngx-loading>
<ng-container *ngIf="filter?.selectedPhoto || photoURL">
  <button class="btn close-btn grey-three-background" (click)="closeLightBox()">
    <i class="fal fa-times"></i>
  </button>
  <div class="d-flex align-items-center h-100 lightbox-container p-2" mat-dialog-content>
    <ng-container *ngIf="filter; else singlePhoto">
      <button class="btn prev-btn navy-font position-absolute p-0" (click)="incrementPhoto(-1)">
        <i class="far fa-arrow-left"></i>
      </button>

      <div class="mw-100 h-100 ml-auto mr-auto">
        <div #zoomContainer class="zoom-container">
          <img
            src="{{ filter?.selectedPhoto.filePath }}"
            (load)="loading = false"
            (error)="loading = false"
            alt="{{ filter?.selectedPhoto?.imageName }}"
          />
        </div>
      </div>

      <button class="btn next-btn navy-font position-absolute p-0" (click)="incrementPhoto(1)">
        <i class="far fa-arrow-right"></i>
      </button>
    </ng-container>
    <ng-template #singlePhoto>
      <div class="mw-100 h-100 ml-auto mr-auto">
        <div #zoomContainer class="zoom-container">
          <img src="{{ photoURL }}" (load)="loading = false" (error)="loading = false" alt="{{ photoURL }}" />
          />
        </div>
      </div>
    </ng-template>
  </div>
</ng-container>
